// extracted by mini-css-extract-plugin
export var $animation_name = "GermanyRichText-module--$animation_name--aef8c";
export var GermanyRichText = "GermanyRichText-module--GermanyRichText--f4bc9";
export var GermanyRichText___christmas = "GermanyRichText-module--GermanyRichText___christmas--800d2";
export var GermanyRichText__contentImage = "GermanyRichText-module--GermanyRichText__contentImage--05330";
export var GermanyRichText__contentImage2 = "GermanyRichText-module--GermanyRichText__contentImage2--abccd";
export var GermanyRichText__image = "GermanyRichText-module--GermanyRichText__image--8c0e1";
export var Links = "GermanyRichText-module--Links--57746";